import { ValueType } from 'realgrid';
import infoIcon from '@/assets/img/group.png';

// LGENSOL용 데이터 필드 정의
const fieldsLGENSOL = [
  { fieldName: '구분', dataType: ValueType.TEXT },
  { fieldName: '고객사원료명칭', dataType: ValueType.TEXT },
  { fieldName: '사내통용명칭', dataType: ValueType.TEXT },
  { fieldName: '조성비', dataType: ValueType.TEXT },
  { fieldName: 'MW', dataType: ValueType.TEXT },
  { fieldName: 'Density', dataType: ValueType.TEXT },
  { fieldName: 'Weight', dataType: ValueType.TEXT },
  { fieldName: 'Volume', dataType: ValueType.TEXT },
  { fieldName: 'SaltWeight', dataType: ValueType.TEXT },
  { fieldName: 'SaltWeightPer', dataType: ValueType.TEXT },
  { fieldName: 'WithAddBase1', dataType: ValueType.TEXT },
  { fieldName: 'WithAddBase2', dataType: ValueType.TEXT },
  { fieldName: 'changeYn', dataType: ValueType.TEXT },
];

// LGENSOL용 컬럼 정의
const columnsLGENSOL = [
  {
    name: '구분',
    fieldName: '구분',
    width: 80,
    editable: false,
    header: { text: '구분', showTooltip: false },
    styles: { textAlignment: 'center' },
    mergeRule: { criteria: 'value' },
  },
  {
    name: '고객사원료명칭',
    fieldName: '고객사원료명칭',
    width: 140,
    editable: false,
    header: { text: '고객사원료명칭', showTooltip: false },
    styles: { textAlignment: 'center' },
  },
  {
    name: '사내통용명칭',
    fieldName: '사내통용명칭',
    width: 120,
    editable: false,
    header: { text: '사내통용명칭', showTooltip: false },
    styles: { textAlignment: 'center' },
  },
  {
    name: '조성비',
    fieldName: '조성비',
    width: 100,
    editable: false,
    header: { text: '조성비', showTooltip: false },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'MW',
    fieldName: 'MW',
    width: 100,
    editable: false,
    header: { text: 'Mw(g/mol)', showTooltip: false },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'Density',
    fieldName: 'Density',
    width: 100,
    editable: false,
    header: { text: 'Density(g/cm³)', showTooltip: false },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'Weight',
    fieldName: 'Weight',
    width: 100,
    editable: false,
    header: { text: '(2)*(4)', showTooltip: false },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'Volume',
    fieldName: 'Volume',
    width: 100,
    editable: false,
    header: { text: '(2)/(4)', showTooltip: false },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'SaltWeight',
    fieldName: 'SaltWeight',
    width: 120,
    editable: false,
    header: { text: '(2)*(3)', showTooltip: false },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'SaltWeightPer',
    fieldName: 'SaltWeightPer',
    width: 120,
    editable: false,
    header: {
      text: '수식',
      template: "<span class='rg-formula-header'>수식 <img src='" + infoIcon + "' class='rg-formula-icon' alt='info' /></span>",
      tooltip: `• (Salt1의 8번 값)

((C×B + (6−1)/1000)/C − (C×B + (6−1)/1000)×(Salt2)/(1 + C×(Salt2))) ÷ ((1 + C×(Salt1))/(C×(Salt1)) − C×(Salt2)/(1 + C×(Salt2)))

• (Salt2의 8번 값)

((C×B + (6−1)/1000)/C − (C×B + (6−1)/1000)×(Salt1)/(1 + C×(Salt1))) ÷ ((1 + C×(Salt2))/(C×(Salt2)) − C×(Salt1)/(1 + C×(Salt1)))`,
      showTooltip: true,
    },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'WithAddBase1',
    fieldName: 'WithAddBase1',
    width: 120,
    editable: false,
    header: {
      text: '수식',
      template: "<span class='rg-formula-header'>수식 <img src='" + infoIcon + "' class='rg-formula-icon' alt='info' /></span>",
      tooltip: `수식 (구분별):
• Solvents: (5)/(5-1)*(100-A-(8-1))
• Salt: (8)값을 소수점 셋째자리 반올림
• Additives: Ratio 값 그대로 적용`,
      showTooltip: true,
    },
    styles: { textAlignment: 'center' },
  },
  {
    name: 'WithAddBase2',
    fieldName: 'WithAddBase2',
    width: 120,
    editable: false,
    header: { text: '소수점 조정', showTooltip: false },
    styles: { textAlignment: 'center' },
  },
];

// LGENSOL용 3단 헤더 레이아웃 정의
const columnLayoutLGENSOL = [
  // 첫 번째, 두 번째 컬럼은 단독으로 3행 span
  '구분',
  '고객사원료명칭',

  // (1) 사내통용명칭 그룹
  {
    name: 'group1',
    direction: 'horizontal',
    header: { text: '(1)', showTooltip: false },
    items: ['사내통용명칭'],
  },

  // (2) 조성비 그룹
  {
    name: 'group2',
    direction: 'horizontal',
    header: { text: '(2)', showTooltip: false },
    items: ['조성비'],
  },

  // (3) MW 그룹
  {
    name: 'group3',
    direction: 'horizontal',
    header: { text: '(3)', showTooltip: false },
    items: ['MW'],
  },

  // (4) Density 그룹
  {
    name: 'group4',
    direction: 'horizontal',
    header: { text: '(4)', showTooltip: false },
    items: ['Density'],
  },

  // (5) Weight 그룹
  {
    name: 'group5',
    direction: 'horizontal',
    header: { text: '(5)' },
    items: [
      {
        name: 'subgroup5',
        direction: 'horizontal',
        header: { text: 'Solvent 무게비', showTooltip: false },
        items: ['Weight'],
      },
    ],
  },

  // (6) Volume 그룹
  {
    name: 'group6',
    direction: 'horizontal',
    header: { text: '(6)' },
    items: [
      {
        name: 'subgroup6',
        direction: 'horizontal',
        header: { text: 'Additive 부피비', showTooltip: false },
        items: ['Volume'],
      },
    ],
  },

  // (7) Vol.Solv.(WT%) 그룹
  {
    name: 'group7',
    direction: 'horizontal',
    header: { text: '(7)' },
    items: [
      {
        name: 'subgroup7',
        direction: 'horizontal',
        header: { text: 'Salt Weight', showTooltip: false },
        items: ['SaltWeight'],
      },
    ],
  },

  // (8) Vol.Solv.(ml) 그룹
  {
    name: 'group8',
    direction: 'horizontal',
    header: {
      text: '(8)',
      showTooltip: false,
    },
    items: [
      {
        name: 'subgroup8',
        direction: 'horizontal',
        header: {
          text: 'Salt wt%',
          showTooltip: false,
        },
        items: ['SaltWeightPer'],
      },
    ],
  },

  // (9) WithAddBase1 그룹
  {
    name: 'group9',
    direction: 'horizontal',
    header: {
      text: '(9)',
      showTooltip: false,
    },
    items: [
      {
        name: 'subgroup9',
        direction: 'horizontal',
        header: {
          text: 'Weight of 100 g base',
          showTooltip: false,
        },
        items: ['WithAddBase1'],
      },
    ],
  },

  // (10) WithAddBase2 그룹
  {
    name: 'group10',
    direction: 'horizontal',
    header: { text: '(10)' },
    items: [
      {
        name: 'subgroup10',
        direction: 'horizontal',
        header: { text: 'Weight of 100 g base', showTooltip: false },
        items: ['WithAddBase2'],
      },
    ],
  },
];

const rowSetLGENSOL = [];
const errorMessageLGENSOL = 'LGENSOL 질량비 계산 데이터가 없습니다';
const hideCheckBarLGENSOL = true;
const blankGridLGENSOL = true;

export { fieldsLGENSOL, columnsLGENSOL, columnLayoutLGENSOL, rowSetLGENSOL, errorMessageLGENSOL, hideCheckBarLGENSOL, blankGridLGENSOL };
